import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const InspectionItemsService = {
    list: async () => axios.get(API_URL + "/inspection-items/list").then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(API_URL + "/inspection-items", data).then(({data}) => data).catch((err) => { throw err }),
    update: async (data, id) => axios.put(API_URL + `/inspection-items/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(API_URL + `/inspection-items/${id}`).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/inspection-items/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getAllToSelect: async () => axios.get(API_URL + `/inspectionItems/options/all`).then(({data}) => data.data).catch((err) => { throw err }),
    isInspectionItemInUse: async (id) => axios.get(API_URL + `/inspectionItems/is-inspection-item-in-use/${id}`).then(({data}) => data.data).catch((err) => { throw err }),
};

export default InspectionItemsService;